var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.userData != null)?_c('div',[_c('b-card',{staticClass:"m-0 mt-1",attrs:{"title":"Back Filling"}},[_c('user-back-filling',{attrs:{"uData":_vm.userData}})],1)],1):_c('b-card')}
var staticRenderFns = []

export { render, staticRenderFns }